import script from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChatPanel.vue?vue&type=style&index=0&id=6ff58335&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff58335"]])

export default __exports__